import { msg } from '@lingui/core/macro'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { MoodboardsView } from '~/components/moodboards/moodboards-view'
import { useProjectDetail } from '~/components/projects/project-detail'
import { titleFor } from '~/lib/route-title'

const ProjectMoodboardsRoute = () => {
  const project = useProjectDetail()
  const { board } = Route.useSearch()
  const navigate = Route.useNavigate()

  if (project.wonAt === undefined) {
    return <Navigate from={Route.fullPath} replace to=".." />
  }
  return (
    <MoodboardsView
      moodboardId={board}
      onOpen={(next) => void navigate({ replace: true, search: { board: next } })}
      projectId={project._id}
      readOnly={project.outcome === 'lost'}
      workspaceId={project.workspaceId}
    />
  )
}

export const Route = createFileRoute(
  '/_authenticated/$workspaceSlug/projects/$projectId/moodboards'
)({
  component: ProjectMoodboardsRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Moodboards`) }] }),
  // Keep the opaque URL text raw; MoodboardsView resolves it against the
  // project-scoped list before a typed id reaches a query.
  validateSearch: (search: Record<string, unknown>): { board?: string } => ({
    board: typeof search.board === 'string' ? search.board : undefined,
  }),
})
